<div kalDialogContent>
    <p>Calcul avancé {{data.label}}</p>


    <div>
        <span *ngFor="let node of data.computations" [ngSwitch]="node.type">

            <ng-container *ngSwitchCase="nodeType.Valeur">{{node.Valeur}}</ng-container>
            <ng-container *ngSwitchCase="nodeType.Operateur">{{node.Operateur.Libelle}}</ng-container>
            <ng-container *ngSwitchCase="nodeType.Critere">
                <a class="gup-O-link gup-U-color--400" *ngIf="node.Parametres | arrayNotEmpty; else criterionLabel" (click)="showParams(node)"><ng-container *ngTemplateOutlet="criterionLabel" ></ng-container></a>

                <ng-template #criterionLabel>{{node.Critere.Libelle}}</ng-template>
            </ng-container>
        </span>
    </div>

    <div *ngIf="!!paramsNode">
        <p>Parametres pour le critère "{{paramsNode.Critere}}"</p>
        <app-shared-advanced-rule-criterion-parameters-detail [parameters]="paramsNode.Parametres" ></app-shared-advanced-rule-criterion-parameters-detail>
    </div>
</div>
<div kalDialogFooter>
    <kal-button kalTheme="secondary" (click)="close()">
        Fermer
    </kal-button>
</div>
